import { EventCategory, MenuEvent } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Menu event
const MENU_CLICK = 'Menu Clicked';
const MENU_ELEMENT_CLICK = 'Menu Element Clicked';
function baseMenuEventTracking(
  event_name: typeof MENU_CLICK | typeof MENU_ELEMENT_CLICK,
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<MenuEvent, 'menuName' | 'position' | 'text'>
) {
  eventTracking<MenuEvent>(analytics, {
    ...props,
    event_name,
    category: EventCategory.FUNNELS,
  });
}

export const menuEventTracking = (analytics: ReturnType<typeof lendiAnalytics>) => ({
  click: baseMenuEventTracking.bind(undefined, MENU_CLICK).bind(null, analytics),
  elementClick: baseMenuEventTracking.bind(undefined, MENU_ELEMENT_CLICK).bind(null, analytics),
});
